import { Injectable } from '@angular/core';
import { ApiService } from '../../../../_core/_services/api.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalTransactionsService {
  constructor(private api: ApiService) {}

  getPortalTransactions() {
    return this.api.getAPI('portal/transactions').pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }

  getPortalTransactionsById(transaction_id: number) {
    return this.api.getAPI(`portal/transactions/${transaction_id}`).pipe(
      map((res: any) => {
        return res.body.data;
      })
    );
  }

  getPortalTransactionsByEndCustomerId(portal_end_customer_id: number, limit = 500) {
    return this.api
      .getAPI(`portal/transactions/customer/${portal_end_customer_id}`, { limit })
      .pipe(
        map((res: any) => {
          return res.body.data;
        })
      );
  }

  getPortalTransactionPayLink(
    transaction: any,
    portal_end_customer_id: number,
    payment_method_override?: string,
    tokenise_payment_method?: boolean
  ) {
    let queryParamters = {};

    if (payment_method_override) {
      queryParamters = {
        payment_method_override: payment_method_override,
        tokenise_payment_method: tokenise_payment_method
      };
    }

    return this.api
      .getAPI(
        `portal/transactions/${portal_end_customer_id}/pay/${transaction && transaction.id}`,
        queryParamters
      )
      .pipe(
        map((res: any) => {
          return res.body;
        })
      );
  }

  /**
   * Ready-to-submit, signed PayFast checkout payload for a transaction -
   * action_url + form fields (including a real `signature`). The backend
   * computes everything, including the signature - no merchant secret ever
   * reaches this call's response. returnUrl/cancelUrl let a caller (e.g. a
   * mobile app opening this in a WebView) override where PayFast redirects
   * on completion/cancellation instead of the default web confirmation
   * pages.
   *
   * paymentToken authorizes this call in place of a logged-in portal
   * session - see PortalRedirectComponent, which is opened from the FTTHSA
   * mobile app's WebView or a third-party portal, neither of which carries
   * this app's normal login session.
   */
  getPayfastCheckoutPayload(
    portal_end_customer_id: number,
    portal_transaction_id: number,
    returnUrl?: string,
    cancelUrl?: string,
    paymentToken?: string
  ) {
    const queryParams: { return_url?: string; cancel_url?: string; payment_token?: string } = {};
    if (returnUrl) queryParams.return_url = returnUrl;
    if (cancelUrl) queryParams.cancel_url = cancelUrl;
    if (paymentToken) queryParams.payment_token = paymentToken;

    return this.api
      .getAPI(
        `portal/transactions/${portal_end_customer_id}/payfast-checkout/${portal_transaction_id}`,
        queryParams
      )
      .pipe(
        map((res: any) => {
          return res.body.data;
        })
      );
  }
}
